export default __webpack_public_path__ + "static/media/gallery_20.f26e60e4.jpg";